import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import {
    getPageLinkByNodeId,
    useGetLinks,
} from "@insite/client-framework/Store/Links/LinksSelectors";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { useMergeStyles } from "@insite/content-library/additionalStyles";
import { StyledButton } from "@insite/mobius/Clickable";
import Link from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import getColor from "@insite/mobius/utilities/getColor";
import * as React from "react";
import { FC, useEffect} from "react";
import { connect } from "react-redux";
import { css } from "styled-components";
import { AccordionSectionPresentationProps, ManagedAccordionSection } from "@insite/mobius/AccordionSection";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import ADIColors from "@NA/Utils/ADIColors";

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => ({
    isAuthenticated: state.context.session!.isAuthenticated,
});

type Props = OwnProps &
    ReturnType<typeof mapStateToProps>

const enum fields {
    direction = "direction",
    alignment = "alignment",
    links = "links",
    title = "title",
    urlType = "urlType",
    telephoneNo = "telephoneNo",
}

interface LinkModelExtended {
    fields: {
        openInNewWindow: boolean;
        overriddenTitle: string;
        destination: LinkFieldValue;
        urlType: string;
        telephoneNo: string;
    };
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.direction]: "vertical" | "horizontal";
        [fields.alignment]: "left" | "center" | "right";
        [fields.title]: string;
        [fields.links]: LinkModelExtended[];
        [fields.urlType]: "telephoneNo" | "destinationUrl";
        [fields.telephoneNo]: string;
    };
    extendedStyles?: ADIConnectWithUsLinkListStyles;
    title: string;
    expandByDefault: boolean;
}

export interface ADIConnectWithUsLinkListStyles {
    containerWrapper?: InjectableCss;
    linkWrapper?: InjectableCss;
    linkListStyle?: InjectableCss;
    titleWrapper?: InjectableCss;
    title?: TypographyPresentationProps;
    destinationUrlStyle?: InjectableCss;
    urlMobileStyle?: InjectableCss;
    linkListWrapper?: InjectableCss;
    accordionSection?: AccordionSectionPresentationProps;
    liveChatLink?: InjectableCss;

}

export const adiConnectWithUslinkListStyles: ADIConnectWithUsLinkListStyles = {
    accordionSection: {
        toggleIconProps: {
            size: 24,
            css: css`
                margin-right: 20px;
            `,
        },
        headerProps: {
            css: css`
                background: transparent;
                -webkit-tap-highlight-color: transparent;
                -webkit-touch-callout: none;
                -webkit-user-select: none;
                -khtml-user-select: none;
                -moz-user-select: none;
                -ms-user-select: none;
                user-select: none;
                > button {
                    border: 0;
                    padding: 0;
                    background: transparent;
                    margin: 0px;
                    :focus {
                        border: 0 !important;
                        outline: 0 !important;
                        padding: 0px;
                    }
                     ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        null,
                        null,
                        css`pointer-events: none;`,
                        css`pointer-events: none;`,
                        css`pointer-events: none;`,
                    ],)}
                    span[class^="IconWrapper-"] {
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(theme, [
                                null,
                                null,
                                css`display: none;`,
                                css`display: none;`,
                                css`display: none;`,                          
                            ],)}
                        margin-right: 0px!important;
                        > svg {
                            color: ${ADIColors.white};
                            stroke-width: 3px;
                        }
                    }
                }
                > button[aria-expanded="true"], button[aria-expanded="false"] {
                    span[class^="IconWrapper-"] {
                        padding: 0px;
                        margin: 0px;
                    }
                }
            `,
        },

        titleTypographyProps: {
            weight: "bold",
            css: css`
            `,
        },

        panelProps: {
            css: css`
                padding: 0px;
                border: none;
                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`padding: 0 20px;`,
                    css`padding: 0 20px;`,
                    css`display: block!important;`,
                    css`display: block!important;`,
                    css`display: block!important;`,
                ],)}
            `,
        },
    },
    linkListWrapper: {
        css: css`
            padding: 10px 0;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`padding: 0px; background-color: blue;`,
                    css`padding: 0px; background-color: blue;`,
                    null,
                    null,
                    null,
                ],)}
        `,
    },
    titleWrapper: {
        css: css`
        font-weight: bold;
        >${StyledButton}{
            >${TypographyStyle} {
                font-size: 16px;
                color: ${getColor("text.main")};
                font-weight: 700;
                line-height: 1.5;
                ${({ theme }) => {
                return breakpointMediaQueries(
                    theme, [null, css` font-size: 18px; font-weight: 800; line-height: normal; `,], "max",);
            }} 
            }
        }
    `,
    },
    title: {
        css: css`
        font-size: 16px;
        color: ${getColor("text.main")};
        font-weight: 700;
        line-height: 1.5;
        ${({ theme }) => {
            return breakpointMediaQueries(
                theme, [null, css` font-size: 18px; font-weight: 800; line-height: normal; `,], "max",);
        }} 
    `,
    },
    linkWrapper: {
        css: css`
        padding: 1px 0px 0 0;
        font-weight: 600;
        div[class^="sc"] {
            >${StyledButton}{
                &:focus{
                    outline: none;
                    text-decoration: underline;
                    color: ${ADIColors.gray6}!important;
                }
                &:hover{
                    color: ${getColor("text.main")};
                    >${TypographyStyle}{
                        color: ${ADIColors.gray6}!important;
                    }
                }
                >${TypographyStyle}{
                    font-size: 14px;
                    line-height: 24px;
                    margin-top: 12px;
                    color: ${getColor("text.main")};
                    ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`margin-top: 10px;line-height:normal;`,
                        css`margin-top: 10px;line-height:normal;`,
                        css`margin-top: 10px;line-height:normal;`,
                        null,
                        null,
                    ],)}
                    &:hover{
                        color: ${getColor("text.main")};
                        text-decoration: underline;
                    }
                }
            }
        }
    `,
    },
    liveChatLink: {
        css: css`
        > ${TypographyStyle} {
            cursor: pointer;
            font-size: 14px;
            color: #f7f7f7;
            margin-top: 12px;
            line-height: 24px;
            display: inline-flex;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme, [null, css` margin-top: 10px; `,], "max",);
            }} 
        }
        `,
    },
};
const initExpanded = () => {
    return true;
};

export const ADIConnectWithUsLinkList: FC<Props> = ({ fields, title, expandByDefault, extendedStyles, isAuthenticated }) => {
    const links = useGetLinks(fields.links, o => o.fields.destination);
    const styles = useMergeStyles("linkList", adiConnectWithUslinkListStyles, extendedStyles);
    const [isMobile, setIsMobile] = React.useState<boolean>(false);

    const alignmentStyles = css`
        text-align: ${fields.alignment || "right"};
        ${styles.linkListWrapper?.css}
    `;

    const directionStyles = css`
        ${fields.direction === "horizontal" ? "display: inline-block;" : "padding: 1px 0 0 0;"};
        ${styles.linkWrapper?.css};
    `;

    const onWindowResize = () => {
        if (typeof window !== "undefined") {
            if (window.innerWidth >= 768) {
                setIsMobile(false);
            } else {
                setIsMobile(true);
            }
        }
    };
    useEffect(() => {
        onWindowResize();

        if (typeof window !== "undefined") {
            window.addEventListener("resize", onWindowResize);
        }

        return () => {
            if (typeof window !== "undefined") {
                window.removeEventListener("resize", onWindowResize);
            }
        };
    }, []);
    return (
        <StyledWrapper {...alignmentStyles} className="list-wrapper">
            <ManagedAccordionSection
                title={
                    <StyledWrapper className="title-wrapper" {...styles.titleWrapper}>
                        <Typography className="list-title" {...styles.title}>
                            {fields.title}
                        </Typography>
                    </StyledWrapper>
                }
                {...styles.accordionSection}
                initialExpanded={(fields.title !== "THE COMPANY" ? expandByDefault : true)}
            >
                <StyledWrapper className="list-wrapper">
                    {links.map((list, index) => (
                        // eslint-disable-next-line react/no-array-index-key
                        <StyledWrapper
                            data-test-selector={fields.links[index].fields.urlType}
                            className="links-wrapper"
                            key={index}
                            css={directionStyles}
                        >
                            {!fields.links[index].fields.urlType && (
                                <>
                                    <Typography as="p" data-test-selector="addressLinks" {...styles.linkListStyle}>
                                        {fields.links[index].fields.overriddenTitle || list.title}
                                    </Typography>
                                </>
                            )}
                            <StyledWrapper {...styles.urlMobileStyle}>
                                {fields.links[index].fields.urlType === "telephoneNo" && (
                                    <>
                                        <Link
                                            data-test-selector="telephoneNoLink"
                                            href={`tel:${fields.links[index].fields.telephoneNo}`}
                                            target={fields.links[index].fields.openInNewWindow ? "_blank" : "_top"}
                                            {...styles.linkListStyle}
                                            className="list-link"
                                        >
                                            {fields.links[index].fields.overriddenTitle || list.title}
                                        </Link>
                                    </>
                                )}
                                {fields.links[index].fields.urlType === "destinationUrl" && (
                                    <>
                                        <Link
                                            data-test-selector="destinationUrlLink"
                                            href={list.url}
                                            target={fields.links[index].fields.openInNewWindow ? "_blank" : "_self"}
                                            {...styles.linkListStyle}
                                            {...styles.destinationUrlStyle}
                                            className="list-link"
                                        >
                                            {fields.links[index].fields.overriddenTitle || list.title}
                                        </Link>
                                    </>
                                )}
                            </StyledWrapper>
                        </StyledWrapper>
                    ))}
                    <StyledWrapper
                            data-test-selector="telephoneNoLink"
                            className="links-wrapper"
                            css={directionStyles}
                        >
                        <StyledWrapper {...styles.urlMobileStyle}>
                            <>
                                <Link
                                    data-test-selector="telephoneNoLink"
                                    href="tel:1.800.234.7971"
                                    target="_blank"
                                    {...styles.linkListStyle}
                                    className="list-link"
                                >
                                    System Design <b>1.800.234.7971</b>
                                </Link>
                            </>
                        </StyledWrapper>
                        <StyledWrapper {...styles.urlMobileStyle}>
                            <>
                                <Link
                                    data-test-selector="telephoneNoLink"
                                    href="tel:1.877.228.6739"
                                    target="_blank"
                                    {...styles.linkListStyle}
                                    className="list-link"
                                >
                                    Customer Care <b>1.877.228.6739</b>
                                </Link>
                            </>
                        </StyledWrapper>
                    </StyledWrapper>
                </StyledWrapper>
            </ManagedAccordionSection>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, null)(ADIConnectWithUsLinkList),
    definition: {
        group: "Basic",
        icon: "ax-link-list",
        displayName: "ADI Connect With Us Link",
        fieldDefinitions: [
            {
                name: fields.direction,
                editorTemplate: "DropDownField",
                defaultValue: "vertical",
                fieldType: "General",
                options: [
                    {
                        displayName: "Vertical",
                        value: "vertical",
                    },
                    {
                        displayName: "Horizontal",
                        value: "horizontal",
                    },
                ],
                hideEmptyOption: true,
            },
            {
                name: fields.alignment,
                editorTemplate: "DropDownField",
                defaultValue: "left",
                fieldType: "General",
                options: [
                    {
                        displayName: "Left",
                        value: "left",
                    },
                    {
                        displayName: "Center",
                        value: "center",
                    },
                    {
                        displayName: "Right",
                        value: "right",
                    },
                ],
                hideEmptyOption: true,
            },
            {
                name: fields.title,
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
            },
            {
                name: fields.links,
                editorTemplate: "ListField",
                getDisplay: (item: HasFields, state) => {
                    const {
                        destination: { type, value },
                        overriddenTitle,
                    } = item.fields;
                    if (overriddenTitle) {
                        return overriddenTitle;
                    }
                    if (type === "Page") {
                        const link = getPageLinkByNodeId(state, value);
                        return link?.title;
                    }
                    if (type === "Category") {
                        let displayValue = "";
                        const categories = (state as any).pageEditor.categories;
                        if (!categories) {
                            displayValue = "Loading...";
                        } else {
                            const matchingCategories = categories.filter((o: { id: string }) => o.id === value);
                            if (matchingCategories.length === 0) {
                                displayValue = "Unknown";
                            } else {
                                displayValue = matchingCategories[0].shortDescription;
                            }
                        }

                        return displayValue;
                    }
                    if (type === "Url") {
                        return value;
                    }
                    return value;
                },
                defaultValue: [],
                fieldType: "General",
                fieldDefinitions: [
                    {
                        name: fields.urlType,
                        displayName: "Url Type",
                        editorTemplate: "DropDownField",
                        options: [
                            { displayName: "Telephone Number", value: "telephoneNo" },
                            { displayName: "Destination Url", value: "destinationUrl" },
                        ],
                        defaultValue: "",
                    },
                    {
                        name: "destination",
                        editorTemplate: "LinkField",
                        isVisible: widget => widget.fields.urlType === "destinationUrl",
                        defaultValue: {
                            value: "",
                            type: "Page",
                        },
                    },
                    {
                        name: fields.telephoneNo,
                        displayName: "Telephone number",
                        editorTemplate: "TextField",
                        isVisible: widget => widget.fields.urlType === "telephoneNo",
                        defaultValue: "",
                    },
                    {
                        name: "overriddenTitle",
                        displayName: "Title",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                    {
                        name: "openInNewWindow",
                        editorTemplate: "CheckboxField",
                        defaultValue: false,
                    },
                ],
            },
        ],
    },
};

export default widgetModule;
